

















































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {ReponsavelAssociado} from '@/model/resource/ReponsavelAssociado'
import {ReponsavelAssociadoCollection} from '@/model/collection/ReponsavelAssociadoCollection'
import {ListReponsavelAssociadoSchema} from '@/schema/resource/ReponsavelAssociado/ListReponsavelAssociadoSchema'
import {CsvReponsavelAssociadoSchema} from '@/schema/resource/ReponsavelAssociado/CsvReponsavelAssociadoSchema'

@Component
export default class ListReponsavelAssociadoView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListReponsavelAssociadoSchema()
  collection = new ReponsavelAssociadoCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: ReponsavelAssociado) {
    Helper.pushByName('editReponsavelAssociado', item.$id)
  }

  async removeItem(item: ReponsavelAssociado) {
    await new DialogRemove(item).confirm(() => item.removeReponsavelAssociado())
    await this.collection.listReponsavelAssociado()
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new ReponsavelAssociadoCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvReponsavelAssociado()
    new CsvReponsavelAssociadoSchema().downloadCsv(csv.all())
  }
}
